import { Link as RacLink } from 'react-aria-components';
import styled from 'styled-components';

export const Link = styled(RacLink)<{
  $isRound: boolean;
  $width?: number;
}>`
  display: flex;
  border-radius: ${props => (props.$isRound ? 'var(--radius-fullyrounded)' : 'var(--radius-base)')};
  width: ${props => (props.$width ? `${props.$width}px` : 'fit-content')};

  &[data-focus-visible] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  & svg {
    // The majority of the SVGs in @/assets/icons were built at 24px width,
    // so this seems like a safe default.
    width: ${props => (props.$width ? `${props.$width}px` : '24px')};
  }
`;
